import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AppConfig } from "src/app/app.config";
import { DatastoreService } from "src/app/services/datastore.service";
import { DobValidatorService } from "src/app/services/dob-validator.service";
import { ApiService } from "src/app/services/jrni/api.service";
import { AvailabilityService } from "src/app/services/jrni/availability.service";
import { BasketService } from "src/app/services/jrni/basket.service";
import { DepartmentService } from "src/app/services/jrni/department.service";
import { MemberService } from "src/app/services/jrni/member.service";
import { ServicesService } from "src/app/services/jrni/services.service";
import { AlertService } from "src/app/_alert";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from "@angular/material";
import { LoginPopupComponent } from "src/app/components/login-popup-modal/login-popup/login-popup.component";
import { FormBuilderService } from "src/app/services/form-builder.service";

@Component({
  selector: "app-booking-details",
  templateUrl: "./booking-details.component.html",
  styleUrls: ["./booking-details.component.scss"],
})
export class BookingDetailsComponent implements OnInit {
  parentDepartment;
  selectedDepartment;
  selectedService;
  pageTitle: string;
  dataPolicy: string;
  declaration_question_override: string;
  bookingDetailsPageText: string;
  bookingQuestions = [];
  submitted: boolean;
  selectedLocation;
  vehicleStatus: any = 0;
  disableVehicleType: any = false;
  requiresFullRegistration = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  bookingQuestionsConfig = AppConfig.settings.bookingQuestions;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  addresses = [];
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  customerQuestions;
  unavailableTimes = [];
  dvlaLookup: boolean = false;
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator = '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2}))$'
  showingAddresses = false;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  selectedAddressId;
  nr: any = window['newrelic'];

  myVehicles: any = [];
  myAddresses: any = [];
  maxChildren: number = 3
  idLocalAddress: boolean = true;
  emailValidationId = "362"

  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private formBuilder: FormBuilder,
    private basketService: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    private datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    public formService: FormBuilderService,
    private apiService: ApiService,
    private availabilityService: AvailabilityService
  ) { }

  // Initialise the customer form
  customerDetailsForm: FormGroup = new FormGroup({
    first_name: new FormControl("", Validators.required),
    last_name: new FormControl("", Validators.required),
    email_address: new FormControl("", [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i)]),
    // postcode: new FormControl("", [Validators.required, Validators.pattern(this.postcodeValidator)]),
    data_policy: new FormControl(false, Validators.requiredTrue)
  }, {
    validators: this.matchingEmailsValidator('email_address', this.emailValidationId)
  });

  addressEnabled = AppConfig.settings.addressApi.enabled;

  matchingEmailsValidator(emailKey: string, confirmEmailKey: string): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {

      let email = group.controls[emailKey];
      let confirmEmail = group.controls[confirmEmailKey];

      // If the email and confirm email inputs have data
      if (email.value.length > 0 && confirmEmail.value.length > 0) {
        // Check if the emails match
        if (email.value.toLowerCase() !== confirmEmail.value.toLowerCase()) {
          confirmEmail.setErrors({ mismatch: true });
          return {
            mismatch: true
          };
        } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
          // If the errors object does not contain any other errors then set errors {} to null
          if (Object.keys(confirmEmail.errors).length == 1) {
            confirmEmail.setErrors(null);
          } else {
            // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
            delete confirmEmail.errors.mismatch;
          }
        } else {
          confirmEmail.setErrors(null);
          return null;
        }
      }
    };
  }

  // Initialise the form
  bookingQuestionsForm: FormGroup = this.formBuilder.group({});

  // Getter for easy access to form fields
  get form() {
    return this.customerDetailsForm.controls;
  }
  get bookingForm() {
    return this.bookingQuestionsForm.controls;
  }

  routerGoBack() {
    this.router.navigate(["/calendar"]);
  }

  restartJourney() {
    this.router.navigate(["/access"]);
  }

  localAddress() {

    this.datastoreService.idLocalAddress = this.formService.localAddress(this.customerDetailsForm.value.selectedAddress.address)
    return this.datastoreService.idLocalAddress
  }

  async getPostcode() { // for when selecting from a client's prefilled list of addresses
    let address: String = this.customerDetailsForm.value['selectedAddress'];
    const selectedAddress = this.myAddresses.find((x) => x.address === address)
    // populate the postcode question
    this.customerDetailsForm.controls['postcode'].setValue(selectedAddress.postcode);
    this.customerDetailsForm.controls['postcode'].patchValue(selectedAddress.postcode);
    // check if it is local
    const res: any = await this.apiService.get(this.customerDetailsForm.value.postcode)
    const foundAddress = res.results.find((x) => {
      if (x.DPA) {
        return x.DPA.ADDRESS === address
      } else if (x.LPI) {
        return x.LPI.ADDRESS === address
      } else {
        return false
      }
    })
    if (foundAddress) {
      this.idLocalAddress = this.formService.localAddress(foundAddress)
    } else {
      console.log("error: could not find address address in ", res)
      this.idLocalAddress = false
    }
    console.log("this.idLocalAddress", this.idLocalAddress)
    this.datastoreService.idLocalAddress = this.idLocalAddress
  }


  async getVehicle() {
    this.spinner.show();
    let vehiclereg: String = this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId];
    try {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(vehiclereg);

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(' ', vehicleLookup.message.indexOf(':') + 1); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(indexOfErrorCode + 1, indexOfErrorCode + 4);

        if (statusCodeErrorMessage == "404") {
          this.vehicleStatus = 2;
        } else {
          this.vehicleStatus = 3;
        }
        this.datastoreService.vehicleStatus = this.vehicleStatus;
        this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].enable()
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].enable()

      } else {

        this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicleLookup['result'].make);
        this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicleLookup['result'].make);
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicleLookup['result'].colour);
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicleLookup['result'].colour);
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()

        this.vehicleStatus = 1;
        this.datastoreService.vehicleStatus = this.vehicleStatus;
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }

  }

  async populateStoredVehicleDetails() {
    let vehiclereg: String = this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId];
    let vehicle = this.myVehicles.find((x) => x.vehicle_registration === vehiclereg)
    if (vehicle.vehicle_make && vehicle.vehicle_make !== "" && vehicle.vehicle_make !== "undefined") {
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicle.vehicle_make);
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicle.vehicle_make);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicle.vehicle_colour);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicle.vehicle_colour);
      if (vehicle.vehicle_type && vehicle.vehicle_type !== "") {
        const question = this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeQuestionId)
        const typeOption = question.options.find((x) => x.name.toLowerCase() === vehicle.vehicle_type.toLowerCase())
        console.log(typeOption)
        console.log(vehicle)
        console.log(vehicle.vehicle_type)
        this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeQuestionId].setValue(typeOption.name);
        this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeQuestionId].patchValue(typeOption.name);
        console.log(vehicle.vehicle_type.toLowerCase(), 'other')
        console.log(vehicle.vehicle_type.toLowerCase() === 'other')
        if (vehicle.vehicle_type.toLowerCase() === 'other') {
          console.log(this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId])
          if (this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible === false) {
            this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].enable()
            this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible = true
          }
          this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].setValue(vehicle.other_vehicle);
          this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].patchValue(vehicle.other_vehicle);
        } else {
          this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].disable()
          this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible = false
        }
        this.disableVehicleType = true
      }
      this.onQuestionChange()
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
    } else {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(vehiclereg);

      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicleLookup['result'].make);
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicleLookup['result'].make);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicleLookup['result'].colour);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicleLookup['result'].colour);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
    }
    this.vehicleStatus = 1;

    this.datastoreService.vehicleStatus = this.vehicleStatus;
  }

  async getAddress(repopulate: boolean = null) {
    this.showingAddresses = false;

    // Clear the addresses array
    this.addresses.length = 0;
    this.customerDetailsForm.controls.selectedAddress.setValue("");

    // Custom error handling for postcode
    let postcode: String = this.customerDetailsForm.value.postcode.replace(/\s/g, '');
    this.customerDetailsForm.controls.postcode.setValue(postcode)
    if (this.customerDetailsForm.controls.postcode.status == 'INVALID') {
      this.customerDetailsForm.get("postcode").setErrors({ 'invalidPostcode': this.translateService.instant('COMMON.INVALID_POSTCODE') })
      return;
    }
    this.spinner.show();
    const res = await this.apiService.get(this.customerDetailsForm.value.postcode)
    if (this.customerDetailsForm.controls.postcode.errors && this.customerDetailsForm.controls.postcode.errors.invalidPostcode) {
      delete this.customerDetailsForm.controls.postcode.errors.invalidPostcode;
    }
    var object: any = res;
    if (object.results) {
      if (this.customerDetailsForm.controls.postcode.errors && this.customerDetailsForm.controls.postcode.errors.addressNotFound) {
        delete this.customerDetailsForm.controls.postcode.errors.addressNotFound;
      }
      var addresses = object.results;
      // Check if the custodian code that the user has entered matches the solihul custodian code
      // const custodian_codes = [7655, 4625,3720];
      // If no DPA exists, use LPI
      const addressesExist = addresses.filter(e => {
        if (e.DPA) {
          return true;
        } else if (e.LPI) {
          return true;
        }
      });

      const addressException = await this.apiService.getAddressException();
      let expections = [];

      if (addressException) {
        expections = addressException['Items'];
      }

      let added = [];

      if (addressesExist.length > 1) {
        // If it matches up, push the addresses
        addressesExist.forEach((item) => {

          const expectionAddress = expections.find(({ UPRN }) => {

            if (item.DPA) {
              if (UPRN === item.DPA.UPRN) {
                return true;
              }
            }
            if (item.LPI) {
              if (UPRN === item.LPI.UPRN) {
                return true;
              }
            }

            return false;

          });

          const addedAlready = added.find(({ ADDRESS }) => {

            if (item.DPA) {
              if (ADDRESS === item.DPA.ADDRESS) {
                return true;
              }
            }
            if (item.LPI) {
              if (ADDRESS === item.LPI.ADDRESS) {
                return true;
              }
            }

            return false;

          });

          let alreadyEntered = false;

          if (expectionAddress === undefined) {
            alreadyEntered = this.addresses.some(e => {
              if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                return true;
              } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                return true;
              }
            });
          }

          if (!alreadyEntered && addedAlready === undefined) {
            if (item.DPA) {
              this.addresses.push({ address: item.DPA });
              added.push({ ADDRESS: item.DPA.ADDRESS },);
            } else {
              this.addresses.push({ address: item.LPI });
              added.push({ ADDRESS: item.LPI.ADDRESS },);
            }
          }
        });

        if (repopulate) {
          let selectedAddress = this.customerDetailsForm.value.selectedAddress.address.ADDRESS
          for (let i = 0; i < this.addresses.length; i++) {
            let item = this.addresses[i]
            if (selectedAddress == item.address.ADDRESS) {
              this.selectedAddressId = i;
            }
          }
        }
        this.showingAddresses = true;
      } else {
        // If it doesn't match up, show an error message
        this.customerDetailsForm.get("postcode").setErrors({ 'invalidPostcode': this.translateService.instant('COMMON.ADDRESS_NOT_ELIGIBLE') })
      }
    } else {
      this.customerDetailsForm.get("postcode").setErrors({ 'addressNotFound': this.translateService.instant('COMMON.ADDRESS_NOT_FOUND') })
    }
    this.spinner.hide();

  }


  bannedRegistrationCheck(registration) {
    // Banned vehicle registrations from API

    if (this.parentDepartment.extra.banned_vehicle_registration_numbers) {
      // If there are any banned vehicle registration numbers, run the check
      var str = this.parentDepartment.extra.banned_vehicle_registration_numbers.replace(/\s/g, '').toLowerCase();
      var banned = new Array();
      banned = str.split(",");

      // Value to return
      var canContinue: Boolean = true;
      // Check for match between banned registrations and users registration
      banned.forEach(item => {
        if (item == registration.replace(/\s/g, '').toLowerCase()) {
          canContinue = false;
        }
      });
      return canContinue;
    } else {
      // If there are no banned vehicle registration numbers, always return true
      return true;
    }

  }


  formatPostcode() {

  }

  ngOnInit() {
    this.scrollToTop();
    if (this.addressEnabled) {
      this.customerDetailsForm.addControl('postcode', new FormControl("", [Validators.required, Validators.pattern(this.postcodeValidator)]));
      this.customerDetailsForm.addControl('selectedAddress', new FormControl("", Validators.required));
    }

    this.availabilityService.getSelectedSlot().then(slot => {
      if (slot) {
        this.slot = slot
      }
    })

    this.dvlaLookup = AppConfig.settings.dvlaLookup;

    this.parentDepartment = this.datastoreService.parentDepartment;

    if (this.parentDepartment) {
      this.spinner.show();
      this.selectedDepartment = this.datastoreService.selectedDepartment;
      let registrationOption = '';
      let organisationQuestionsID;

      // Set the title on the login page to the title from the business question
      this.parentDepartment.extra?.hasOwnProperty(
        "booking_details_page_title"
      )
        ? (this.pageTitle = this.parentDepartment.extra.booking_details_page_title)
        : (this.pageTitle = "Booking details title not set");

      // Get the configurable data
      if (this.parentDepartment.hasOwnProperty("extra")) {
        // Set the extra text on the page to the text taken from the business question

        this.parentDepartment.extra.hasOwnProperty("data_policy")
          ? (this.dataPolicy = this.parentDepartment.extra.data_policy)
          : (this.dataPolicy = "data policy not set");

        this.parentDepartment.extra.hasOwnProperty("declaration_question_override")
          ? (this.declaration_question_override = this.parentDepartment.extra.declaration_question_override)
          : (this.declaration_question_override = "declaration question not set");

        this.parentDepartment.extra.hasOwnProperty(
          "booking_details_page_text"
        )
          ? (this.bookingDetailsPageText = this.parentDepartment.extra.booking_details_page_text)
          : null;

        // Set the extra text on the page to the text taken from the business question
        this.parentDepartment.extra.hasOwnProperty(
          "booking_details_page_text"
        )
          ? (this.bookingDetailsPageText = this.parentDepartment.extra.booking_details_page_text)
          : null;
        // Get the registration option
        this.parentDepartment.extra.hasOwnProperty("registration_option")
          ? (registrationOption = this.parentDepartment.extra
            .registration_option)
          : null;
        // Get the organistion customer questions
        this.parentDepartment.extra.hasOwnProperty(
          "organisations_questions"
        )
          ? (organisationQuestionsID = this.parentDepartment.extra
            .organisations_questions)
          : null;

        // If the register option is set to complete a full registration then capture the following details
        if (registrationOption.toLowerCase() === "register complete details") {
          this.requiresFullRegistration = true;
        }
      }

      //     // Use this.departmentService.getLocation() if the services are set on the children departments
      //     // Use this.departmentService.get() if the services are set on the parent department
      this.departmentService.get().then(async (location) => {
        this.selectedLocation = location;

        // Delete any exisitng baskets to avoid conflicts
        // if (this.basketService.currentBasket) {
        //   await this.basketService.delete(
        //     this.selectedLocation,
        //     this.basketService.currentBasket
        //   );
        // }
        // Create the basket


        this.memberService.getMember().then(async (member) => {
          this.member = member;

          // Get the customer questions
          this.departmentService.getCustomerQuestions().then(async (questions) => {

            this.customerQuestions = questions;
            this.datastoreService.customerQuestions = questions;
            for (let index = 0; index < this.customerQuestions.length; index++) {
              const question = this.customerQuestions[index];
              question.visible = false;
              question.reference = question.id;
              if (!question.admin_only) {
                if (!question.settings.hasOwnProperty('conditional_question')) {
                  question.visible = true;
                }

                const questionControl = question.id;
                if (question.detail_type == 'check' || question.detail_type == 'check-price') {
                  if (question.default == 1) {
                    if (question.required) {
                      this.customerDetailsForm.addControl(questionControl, new FormControl(true, Validators.required));
                    } else {
                      this.customerDetailsForm.addControl(questionControl, new FormControl(true));
                    }
                  } else {
                    if (question.required) {
                      this.customerDetailsForm.addControl(questionControl, new FormControl(false, Validators.required));
                    } else {
                      this.customerDetailsForm.addControl(questionControl, new FormControl(false));
                    }
                  }
                } else {
                  if (questionControl === 382) {  // postcode custom question needs validation
                    if (!this.addressEnabled) {  // postcode custom question not needed if we are doing address lookup
                      if (question.required) {
                        this.customerDetailsForm.addControl(questionControl, new FormControl('', [Validators.required, Validators.pattern(this.postcodeValidator)]));
                      } else {
                        this.customerDetailsForm.addControl(questionControl, new FormControl('', Validators.pattern(this.postcodeValidator)));
                      }
                      this.customerDetailsForm.get("382").valueChanges.subscribe(value => { //force uppercase and space removal
                        if (value !== value.replace(/\s/g, "").toUpperCase().slice(0, 8)) {
                          this.customerDetailsForm.controls["382"].setValue(value.replace(/\s/g, "").toUpperCase().slice(0, 8));
                        }
                      });
                    }
                  } else {
                    if (question.required) {
                      this.customerDetailsForm.addControl(questionControl, new FormControl('', Validators.required));
                    } else {
                      this.customerDetailsForm.addControl(questionControl, new FormControl(''));
                    }
                  }
                }
              }
            }
            if (this.member) {
              console.log(this.member, this.customerDetailsForm)
              this.populateFromMember(this.member)
              for (let i = 1; i <= this.maxChildren; i++) {
                const address: any = await this.apiService.getHwrcAddressForm(member.id, this.parentDepartment.id, i)
                if (address.hasOwnProperty('Item')) {
                  this.myAddresses.push(address.Item)
                }
                const vehicle: any = await this.apiService.getHwrcVehicleForm(member.id, this.parentDepartment.id, i)
                if (vehicle.hasOwnProperty('Item')) {
                  this.myVehicles.push(vehicle.Item)
                }
              }
            }
            //     // Get the selected service
            this.servicesService.get().then((service) => {
              this.selectedService = service;
              // Get the questions
              this.apiService.questions(service.detail_group_id, this.selectedDepartment.id).then((res: any) => {
                this.bookingQuestions = res.questions;
                this.datastoreService.bookingQuestions = this.bookingQuestions;
                console.log(this.bookingQuestions)
                for (let index = 0; index < res.questions.length; index++) {
                  const question = res.questions[index];
                  question.visible = false;
                  question.reference = question.id;
                  if (!question.admin_only) {
                    if (!question.settings) {
                      question.visible = true;
                    } else if (!question.settings.hasOwnProperty("conditional_question")) {
                      question.visible = true;
                    }
                    const questionControl = question.id;

                    if (question.detail_type == 'check' || question.detail_type == 'check-price') {
                      if (question.required) {
                        this.bookingQuestionsForm.addControl(questionControl, new FormControl(false, Validators.requiredTrue));
                      } else {
                        this.bookingQuestionsForm.addControl(questionControl, new FormControl(false));
                      }
                    } else {
                      if (question.required) {
                        this.bookingQuestionsForm.addControl(questionControl, new FormControl('', Validators.required));
                      } else {
                        this.bookingQuestionsForm.addControl(questionControl, new FormControl(''));
                      }
                    }
                  }
                }
                // Repopulate the booking questions when coming back
                this.datastoreService.bookingForm
                  ? this.repopulateQuestions()
                  : null;
                this.spinner.hide();
              });
            });
          });
        });
      },
        (err) => {
          this.alertService.error(
            this.translateService.instant("COMMON.GENERAL_ERR")
          );
          this.spinner.hide();
        }
      );
    } else {
      this.restartJourney();
    }


  }

  repopulateQuestions() {
    this.bookingQuestionsForm = this.datastoreService.bookingForm;
    this.customerDetailsForm = this.datastoreService.customerDetailsForm;
    console.log("(this.myAddresses", this.myAddresses)
    if (this.myAddresses.length > 0) {
      this.getPostcode()
    }
    if (this.datastoreService.vehicleStatus) {
      this.vehicleStatus = this.datastoreService.vehicleStatus;
    } else {
      this.vehicleStatus = 1;
    }
    let vehiclereg: String = this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId];
    let vehicle = this.myVehicles.find((x) => x.vehicle_registration === vehiclereg)
    if (vehicle) {
      if (vehicle.vehicle_type && vehicle.vehicle_type !== "") {
        this.disableVehicleType = true
      }
    }
    this.onQuestionChange();
  }

  onQuestionChange() {
    const bookingQuestions = this.bookingQuestions;
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {
      const q = bookingQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty("conditional_question")) {
        // Get the conditional question based on the id set in q
        const conditionalQ = bookingQuestions.filter(
          (question) => question.id == q.settings.conditional_question
        );
        // Get the question control
        const questionControl = this.bookingForm[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        const option = conditionalQ[0].options.filter(
          (option) => option.name == questionControl.value
        );
        // If the conditional question is visible and the value chosen === to qs conditional answer then show q
        if (
          conditionalQ.length > 0 &&
          conditionalQ[0].visible &&
          option.length > 0 &&
          q.settings.conditional_answers.hasOwnProperty(option[0].id)
        ) {
          this.bookingForm[q.id].enable();
          // If the condiditonal question is important, Hide it
          if (q.important) {
            q.visible = false;
          } else {
            q.visible = true;
          }
        } else {
          q.visible = false;
          this.bookingForm[q.id].setValue("");
          this.bookingForm[q.id].disable();
        }
      }
    }
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form[questionId].setValue(file, { emitModelToViewChange: false });
      this.bookingQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();
    if (this.vehicleStatus === 0) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      return
    }
    // force the address feild to be upper case
    if (this.customerDetailsForm.value["382"] !== null && this.customerDetailsForm.value["382"] !== undefined) {
      this.customerDetailsForm.controls["382"].setValue(this.customerDetailsForm.value["382"].replace(/\s/g, "").toUpperCase());
    }

    // Check if form is valid
    console.log(this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid)
    console.log(this.customerDetailsForm.invalid, this.bookingQuestionsForm.invalid)
    console.log(this.customerDetailsForm, this.bookingQuestionsForm)
    if (this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      return;
    }
    var currentDate = new Date(this.slot.datetime);

    // for some reason this function sometimes doesn't get run, adding the console logs fixed this (not sure why)

    // await this.apiService.checkForDoubleBooking(
    //   this.selectedDepartment,
    //   currentDate,
    //   this.customerDetailsForm.value.email_address ? this.customerDetailsForm.value.email_address : null,
    //   null
    // ).then((res: []) => {
    //   // res = array of unavailable times
    //   this.unavailableTimes = res

    //   this.completeBooking()
    // })
    this.completeBooking();
  }



  async completeBooking() {

    console.log(this.customerDetailsForm.value.selectedAddress)
    if (this.addressEnabled) {
      if (this.myAddresses.length === 0) {

        console.log(!this.customerDetailsForm.value.selectedAddress.address)
        if (!this.customerDetailsForm.value.selectedAddress.address) {
          this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
          this.scrollToTop();
          this.spinner.hide();
          return;
        }

        let addressFirstPart;
        console.log(this.customerDetailsForm.value.selectedAddress.address)
        if (this.customerDetailsForm.value.selectedAddress.address) {
          const selectedAddress = this.customerDetailsForm.value.selectedAddress.address;
          if (selectedAddress.LPI_KEY) {
            // IF LPI
            if (selectedAddress.PAO_START_NUMBER) {
              addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''} ${selectedAddress.PAO_START_NUMBER}`;
            } else if (selectedAddress.PAO_TEXT) {
              addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''} ${selectedAddress.PAO_TEXT}`;
            }
          } else {
            // IF DPA
            if (this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER && this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME) {
              addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER},`;
            } else {
              if (this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER && this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME) {
                addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER}, ${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}`;
              } else if (this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME && this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME) {
                addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME}`;
              } else {
                if (this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER) {
                  addressFirstPart = this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER;
                } else if (this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME) {
                  addressFirstPart = this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME;
                } else {
                  addressFirstPart = this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME;
                }
              }
            }
          }
        } else {
          this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
          this.scrollToTop();
          this.spinner.hide();
          this.customerDetailsForm.get("selectedAddress").setErrors({
            'required': this.translateService.instant('COMMON.ADDRESS_NOT_FOUND')
          })
          return;
        }

        // Fix issue where the thoroughfare name and street description are not available.
        let address1 = '';
        console.log()
        if (this.customerDetailsForm.value.selectedAddress.address.THOROUGHFARE_NAME || this.customerDetailsForm.value.selectedAddress.address.STREET_DESCRIPTION) {
          address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.value.selectedAddress.address.THOROUGHFARE_NAME ? this.customerDetailsForm.value.selectedAddress.address.THOROUGHFARE_NAME.toLowerCase() :
            this.customerDetailsForm.value.selectedAddress.address.STREET_DESCRIPTION.toLowerCase()}`;
        }
        else {
          address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.value.selectedAddress.address.DEPENDENT_LOCALITY}`;
        }

        this.datastoreService.address1 = address1;
      } else {
        this.datastoreService.address1 = this.customerDetailsForm.value.selectedAddress
      }

      // Check our API if the user has booked already in the past 7 days
      // If there is a weekly booking limit

      // let limitReached = false;

      // let weeklyLimit = this.parentDepartment.extra.booking_limit_per_household_per_week_mon_to_sun;

      // await this.apiService.getWeekOfBookings(address1, this.selectedDepartment, this.slot.datetime, weeklyLimit).then(res => {

      //   // if limitReached is true then user has reached the weekly limit (which is set by the client)
      //   if (res['limitReached'] == true) {
      //     limitReached = true;
      //     this.alertService.error(this.translateService.instant('FORM.HOUSEHOLD_WEEKLY_BOOKING_LIMIT', { limit: weeklyLimit }));
      //     this.scrollToTop();
      //     this.spinner.hide();
      //     return;
      //   } else if (res['Error']) {
      //     limitReached = true;
      //     this.alertService.warn(this.translateService.instant('COMMON.VALIDATION_ERR_MSG'));
      //     this.scrollToTop();
      //     this.spinner.hide();
      //     return;
      //   }
      // });

      // if (limitReached) {
      //   return;
      // }
    }

    const email = this.customerDetailsForm.controls['email_address'].value;

    // Use email/phone to check if the user is banned
    let res, checkAccount;
    try {
      res = await this.apiService.checkEmailNumber(email, null, this.selectedDepartment);

      checkAccount = new Promise((resolve, reject) => {
        if (res == undefined) {
          resolve("finished")
        }
        if (res["_source"] && res["_source"].questions) {
          if (res["_source"].questions.length > 0) {
            res["_source"].questions.forEach((question, index) => {
              if (question.id == 8 && question.answer == "1") {
                reject("banned")
                this.banned = true;
                return;
              }
              if (index === res["_source"].questions.length - 1) {
                resolve("finished");
              }
            });
          } else {
            resolve("finished");
          }
        } else {
          resolve("finished");
        }
      });
    }
    catch (err) {
      console.error(err);
      this.spinner.hide();
      this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
      if (this.nr) {
        this.nr.addPageAction('KCCError', { client: 'kent', host: AppConfig.settings.apiServer, errorMessage: JSON.stringify(err), errorType: 'ELASTICSEARCH_CLIENT' });
      }
    };

    checkAccount.then(async () => {
      const config: any = await this.apiService.getConfig()
      console.log(config)
      if (this.myAddresses.length > 0) {
        if (config.adminDetailQuestions) {
          this.addAdminQuestions(config) // add admin questions and answers if user is logged in and has pre-set addresses/registrations
        } else {
          console.log("company config.adminDetailQuestions object not set!")
          this.scrollToTop();
          this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        }
      } else {
        this.bookingQuestionsForm.addControl(config.adminDetailQuestions.address, new FormControl("", Validators.required))
        this.bookingQuestionsForm.addControl(config.adminDetailQuestions.postcode, new FormControl("", Validators.required))

        this.bookingQuestionsForm.controls[config.adminDetailQuestions.address].setValue(this.customerDetailsForm.value.selectedAddress.address.ADDRESS);
        this.bookingQuestionsForm.controls[config.adminDetailQuestions.address].patchValue(this.customerDetailsForm.value.selectedAddress.address.ADDRESS);

        this.bookingQuestionsForm.controls[config.adminDetailQuestions.postcode].setValue(this.customerDetailsForm.value['postcode']);
        this.bookingQuestionsForm.controls[config.adminDetailQuestions.postcode].patchValue(this.customerDetailsForm.value['postcode']);
      }

      this.datastoreService.bookingForm = this.bookingQuestionsForm;
      this.datastoreService.customerDetailsForm = this.customerDetailsForm;
      console.log(this.bookingQuestionsForm.value[4])
      if (this.bookingQuestionsForm.value[4]) {
        if (this.bannedRegistrationCheck(this.datastoreService.bookingForm.value[4])) {
          if (await this.addItem()) {
            this.gotToSummary()
          } else {
            console.log("add item error")
            this.spinner.hide();
            this.scrollToTop();
            return
          }

        } else {
          this.scrollToTop();
          this.alertService.warn(this.translateService.instant('COMMON.USER_BANNED'));
          this.spinner.hide();
        }
      } else {
        if (await this.addItem()) {
          this.gotToSummary()
        } else {
          console.log("add item error")
          this.spinner.hide();
          this.scrollToTop();
          return
        }
      }

    }).catch((e) => {
      if (e == "banned") {
        this.alertService.warn(this.translateService.instant('COMMON.USER_BANNED'));
      } else {
        this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        if (this.nr) {
          this.nr.addPageAction('KCCError', { client: 'kent', host: AppConfig.settings.apiServer, errorMessage: JSON.stringify(e), errorType: 'ELASTICSEARCH_CLIENT' });
        }
      }
      this.scrollToTop();
      this.spinner.hide();
    });
  }


  removeSpaces(controlName: string) {
    const control = this.customerDetailsForm.get(controlName);
    if (control && control.value) {
      const va = control.value.toLowerCase().replace(/\s+/g, '')
      control.setValue(va.toLowerCase(), { emitEvent: false });
    }
  }

  async addItem() {
    const member = await this.memberService.getMember()
    // if (member === undefined || member === false) { // not adding the item yet
    //   return true // we'll be remaking the basket after we log in/create client anyway
    // }
    // Get the selected slot from the previous page
    const selectedSlot = await this.availabilityService.getSelectedSlot();
    let bookingAnswers = []
    if (this.addressEnabled) {

      if (!this.datastoreService.idLocalAddress) {
        bookingAnswers.push({ //addmin question about if addess is in kent or not
          id: AppConfig.settings.outOfCountry,
          answer: 1,
        });
      }
    }
    // Get the booking answers and add them to an array ready to add to basket
    for (var key in this.datastoreService.bookingForm.value) {
      {
        bookingAnswers.push({
          id: key,
          answer: this.datastoreService.bookingForm.value[key],
        });
      }
    }
    this.datastoreService.bookingAnswers = bookingAnswers;
    console.log(this.datastoreService.basketItem)
    console.log('service_items', { service_item_id: this.datastoreService.basketItem.id }, { questions: bookingAnswers })
    try {
      // res = await this.currentBasket.$put('service_items', { service_item_id: this.datastoreService.basketItem.id }, { questions: bookingAnswers })
      // const res = await this.basketService.updateItem( this.datastoreService.basketItem,bookingAnswers)
      // await this.basketService.deleteAllBaskets(this.selectedDepartment);
      // this.basketService.currentBasket = await this.basketService.createBasket(this.selectedDepartment);

      // Add item to the basket
      // const res = await this.basketService.addItem(
      //   this.selectedLocation,
      //   this.selectedService.id,
      //   this.selectedService.durations[0],
      //   selectedSlot.datetime,
      //   bookingAnswers
      // )
      const res = await this.basketService.updateItem(
        this.selectedLocation,
        this.selectedService.id,
        this.selectedService.durations[0],
        selectedSlot.datetime,
        bookingAnswers
      )

      if (res == "failed") {
        // If conflict/409
        this.alertService.error(this.translateService.instant('SUMMARY.INVALID_SLOT'));
        // this.spinner.hide();
        return false
      }
      return true
    } catch (err) {
      console.log(err)
      this.alertService.error(this.translateService.instant('SUMMARY.INVALID_SLOT'));
      // this.spinner.hide();
      return false
    }

  }

  async showDialog(user) {
    console.log("showlg")
    const dialogRef = this.dialog.open(LoginPopupComponent, {
      width: '1000px',
      data: {
        header: this.translateService.instant('An account is already registered with your email address. Please login, or you may continue as a guest.'),
        action: "login",
        user: user,
        continue: true,
        // location,
        // member: this.member
      }
    });
  }

  async checkIfDupeUser() {
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const res = this.customerDetailsForm.value.email_address.match(emailRegex)
    console.log(res)
    let checkUser: any = false
    if (res && res.length > 0) {
      checkUser = await this.apiService.checkEmailAndName(
        this.customerDetailsForm.value.email_address,
        this.departmentService.selectedDepartment.id
      );
      if (checkUser) {
        // continue if user not found or if jrni account is a contact
        if (checkUser.detail !== "Not Found" && (checkUser.client_type !== "Contact")) {
          // this.customerDetailsForm.controls["email_address"].setValue("")
          // this.customerDetailsForm.controls["email_address"].patchValue("")
          this.showDialog(checkUser);
          return { dupe: true, checkUser: checkUser }
        }
      }
    }
    return { dupe: false, checkUser: checkUser }
  }


  async gotToSummary() {
    let loggedIn = this.memberService.getMember();

    if (loggedIn['__zone_symbol__value']) {
      // Navigate to the checklist page
      this.router.navigate(["/summary"]);

    } else {
      // const needLogin = await this.checkIfDupeUser()
      // if (!needLogin.dupe) {
      this.router.navigate(["/summary"]);
      // }
      return
      // no longer have to be logged in. Handling of this will come later
      // if (!needLogin.dupe) {
      //   let checkUser = needLogin.checkUser
      //   if (checkUser) {
      //     // continue if user not found or if jrni account is a contact
      //     console.log(checkUser)
      //     if (checkUser === "User not found" || checkUser["detail"] === 'Not Found' || (checkUser["client_type"] === "Contact")) {
      //       this.router.navigate(["/summary"]);
      //     } else if (checkUser['_source']) {
      //       if ((checkUser['_source'].member_type === 2 || checkUser['_source'].member_type === null)) {
      //       } else if (checkUser['_source'].reference != null) {
      //         this.alertService.error(this.translateService.instant('LOGIN.NO_TMB_USER_FOUND_ERROR'));
      //         this.scrollToTop();
      //       } else {
      //         this.alertService.error(this.translateService.instant('LOGIN.NO_TMB_USER_FOUND_ERROR'));
      //         this.scrollToTop();
      //       }
      //     } else {
      //       this.alertService.error(this.translateService.instant('LOGIN.NO_TMB_USER_FOUND_ERROR'));
      //       this.scrollToTop();
      //     }
      //   }
      // }
    }
    this.spinner.hide();

  }

  populateFromMember(member) {
    this.customerDetailsForm.controls["first_name"].setValue(member.first_name);
    this.customerDetailsForm.controls["first_name"].patchValue(member.first_name);
    this.customerDetailsForm.controls["first_name"].disable()
    this.customerDetailsForm.controls["last_name"].setValue(member.last_name);
    this.customerDetailsForm.controls["last_name"].patchValue(member.last_name);
    this.customerDetailsForm.controls["last_name"].disable()
    this.customerDetailsForm.controls["email_address"].setValue(member.email);
    this.customerDetailsForm.controls["email_address"].patchValue(member.email);
    this.customerDetailsForm.controls["email_address"].disable()
    this.customerDetailsForm.controls[this.emailValidationId].setValue(member.email);
    this.customerDetailsForm.controls[this.emailValidationId].patchValue(member.email);
    this.customerDetailsForm.controls[this.emailValidationId].disable()
  }

  addAdminQuestions(config) {
    this.bookingQuestionsForm.addControl(config.adminDetailQuestions.address, new FormControl("", Validators.required))
    this.bookingQuestionsForm.addControl(config.adminDetailQuestions.postcode, new FormControl("", Validators.required))
    this.bookingQuestionsForm.addControl(config.adminDetailQuestions.vehicle_registration, new FormControl("", Validators.required))
    this.bookingQuestionsForm.addControl(config.adminDetailQuestions.vehicle_make, new FormControl("", Validators.required))
    this.bookingQuestionsForm.addControl(config.adminDetailQuestions.vehicle_colour, new FormControl("", Validators.required))

    this.bookingQuestionsForm.controls[config.adminDetailQuestions.address].setValue(this.customerDetailsForm.value['selectedAddress']);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.address].patchValue(this.customerDetailsForm.value['selectedAddress']);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.postcode].setValue(this.customerDetailsForm.value['postcode']);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.postcode].patchValue(this.customerDetailsForm.value['postcode']);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_registration].setValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId]);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_registration].patchValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId]);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_make].setValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.makeQuestionId]);
    this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_make].patchValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.makeQuestionId]);
    // this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_colour].setValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.colourQuestionId]);
    // this.bookingQuestionsForm.controls[config.adminDetailQuestions.vehicle_colour].patchValue(this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.colourQuestionId]);

    this.datastoreService.bookingQuestions.push({
      name: config.adminDetailQuestions.address,
      detail_type: 'text_field',
      price: 0
    })
    this.datastoreService.bookingQuestions.push({
      name: config.adminDetailQuestions.postcode,
      detail_type: 'text_field',
      price: 0
    })
    this.datastoreService.bookingQuestions.push({
      name: config.adminDetailQuestions.vehicle_registration,
      detail_type: 'text_field',
      price: 0
    })
    this.datastoreService.bookingQuestions.push({
      name: config.adminDetailQuestions.vehicle_make,
      detail_type: 'text_field',
      price: 0
    })
    this.datastoreService.bookingQuestions.push({
      name: config.adminDetailQuestions.vehicle_colour,
      detail_type: 'text_field',
      price: 0
    })
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
